<div class="list-wrap">

  <div class="list-tit-box"
       *ngIf="dispTxt">{{ dispTxt }}</div>

  <ul #scrollContainer
      class="scroll-effect over-y"
      (scroll)="onScroll($event)">
    <li *ngFor="let hanja of ll?.getList()">
      <app-saseung-item class="item-box"
                        [hanja]="hanja"
                        [hangul]="hangul!"
                        (viewInit)="onItemViewInit($event)">
      <!--              [selected]="selected"-->
      </app-saseung-item>
    </li>

    <li>
      <div class="item-box" *ngIf="! ll?.IsComplete()">
        <div class="reload-icon">
          <img #reload
               src="assets/img/loading_icon.gif">
        </div>
      </div>
    </li>

    <!-- 항목 없음 표시 -->
    <li class="no-result" *ngIf="isNoResult()">
      <div class="no-result-img"></div>
      <div class="no-result-txt">문자가 없습니다.</div>
    </li>  </ul>

</div>
